import React from 'react';
import PropTypes from 'prop-types';
import { FaExclamationTriangle, FaCheckCircle, FaInfoCircle } from 'react-icons/fa';
import Modal from './Modal';
import Button from './Button';

/**
 * Confirmation modal for confirmations, warnings, and alerts
 * Built on top of Modal component
 */
const Confirmation = ({
  show = false,
  title = 'Confirm Action',
  message = '',
  type = 'warning', // warning, danger, success, info
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm = () => {},
  onCancel = () => {},
  loading = false,
  size = 'md',
  showIcon = true,
}) => {
  const iconMap = {
    warning: { icon: FaExclamationTriangle, color: 'tw-text-orange-500' },
    danger: { icon: FaExclamationTriangle, color: 'tw-text-red-500' },
    success: { icon: FaCheckCircle, color: 'tw-text-green-500' },
    info: { icon: FaInfoCircle, color: 'tw-text-blue-500' },
  };

  const variantMap = {
    warning: 'warning',
    danger: 'danger',
    success: 'success',
    info: 'primary',
  };

  const { icon: Icon, color } = iconMap[type];

  return (
    <Modal
      show={show}
      onHide={onCancel}
      title={title}
      size={size}
      style={{ zIndex: 99999 }}
      footer={
        <div className="tw-flex tw-gap-2 tw-justify-end">
          <Button
            variant="ghost"
            onClick={onCancel}
            disabled={loading}
          >
            {cancelText}
          </Button>
          <Button
            variant={variantMap[type]}
            onClick={onConfirm}
            loading={loading}
          >
            {confirmText}
          </Button>
        </div>
      }
    >
      <div className="tw-flex tw-gap-4">
        {showIcon && (
          <div className={`tw-flex-shrink-0 tw-flex tw-items-center`}>
            <Icon size={32} className={color} />
          </div>
        )}
        <div className="tw-flex-1">
          <p className="tw-text-sm tw-text-slate-600 tw-m-0">
            {message}
          </p>
        </div>
      </div>
    </Modal>
  );
};

Confirmation.propTypes = {
  show: PropTypes.bool,
  title: PropTypes.string,
  message: PropTypes.node,
  type: PropTypes.oneOf(['warning', 'danger', 'success', 'info']),
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  loading: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
  showIcon: PropTypes.bool,
};

export default Confirmation;
